"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deregistrationReasonEnums = {
    ADMIN_ILT_DEASSIGNED: 'ILT Deassigned',
    USER_DEREGISTER_FROM_WAITLISTED: 'Registeration switched from previously waitlisted state',
    USER_DEREGISTER_FROM_REGISTERED: 'Registeration switched from previously registered state'
};
//# sourceMappingURL=deregistrationReasonEnums.js.map